import { render, staticRenderFns } from "./NiveauInformatique.vue?vue&type=template&id=611488f8&"
import script from "./NiveauInformatique.vue?vue&type=script&lang=js&"
export * from "./NiveauInformatique.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports